<script setup lang="ts">
definePageMeta({
  layout: "marketing",
  title: "Studentliv",
})

const { cms } = useRuntimeConfig().public

const lookup = computed(() => getLocationIdsFromSlugs({ cms }).studentliv)
</script>

<template>
  <UMarketingArticle :slug-lookup="lookup" />
</template>
